<template>
  <div v-editable="blok">
    <StoryblokComponent
      v-for="component in blok.hero"
      :key="component._uid"
      :blok="component"
      add-nav-height
    />
    <StoryblokComponent
      v-for="component in blok.body"
      :key="component?._uid"
      :blok="component"
    />
  </div>
</template>

<script lang="ts" setup>
import type { SbPageStoryblok } from '@/types'
interface Props {
  blok: SbPageStoryblok
}
defineProps<Props>()
</script>
